import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../../components/tables/tableContext/TableContext";
import { ActiveTransportsDataInterface } from "../../../../../redux/interfaces/transport.interface";
import { getDateAndTime } from "../../../../../utils/dateAndTime";

const activeTransportsStatusValues = [
  { value: 0, label: "Initiat" },
  { value: 1, label: "Incarcat" },
  {
    value: 2,
    label: "Scanare iesire din nod(cand se apasa pe 'Plecare din Nod')",
  },
  { value: 3, label: "Scanare intrare nod" },
  { value: 4, label: "Scanare descarcare marfa in nod" },
  {
    value: 5,
    label:
      "Scanare incarcare marfa in nod (programatic cand se scaneaza de incarcare prima cutie/bin)",
  },
  { value: 9, label: "Finalizat" },
];

const getActiveTransportsLabel = (status: number) => {
  const getStatus = activeTransportsStatusValues.find(
    (item) => item.value === status,
  );
  return getStatus ? getStatus.label : "";
};

const routesTypes = [
  {
    value: 0,
    label: "Toate",
  },
  { value: 1, label: "Rute locale" },
  { value: 2, label: "Rute internod" },
];

export const activeTransportsTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Nr. auto",
    value: "masina",
    minW: 125,
    withSearch: true,
  },
  {
    label: "Sofer",
    value: "sofer",
    minW: 125,
  },
  {
    label: "Ruta",
    value: "ruta",
    minW: 125,
  },
  {
    label: "Ruta internod",
    value: "ruta_intranod",
    minW: 125,
  },
  {
    label: "Data start",
    value: "data_start",
    minW: 125,
  },
  {
    label: "Status",
    value: "tip_ruta",
    minW: 125,
    withFilter: routesTypes,
  },
  {
    label: "Status colete",
    value: "colete_totale",
    minW: 125,
  },
];

export const getactiveTransportsTableData = (
  data: ActiveTransportsDataInterface[],
): TableData[] =>
  data.map((item) => {
    return {
      id: item.id_transport,
      crudData: item,
      data: [
        {
          title: item.masina,
        },
        {
          title: item.sofer,
        },
        {
          title: item.ruta ?? "-",
        },
        {
          title: item.ruta_intranod ?? "-",
        },
        {
          title: getDateAndTime(item.data_start) ?? "-",
        },
        {
          badges: [
            {
              badgeText: getActiveTransportsLabel(item.status),
              badgeColor: "light-info",
            },
          ],
        },
        {
          badges:
            item.id_ruta_intranod === 0
              ? [
                  {
                    badgeText: `Colete totale: ${item.colete_totale}`,
                    badgeColor: "light-info",
                  },
                  {
                    badgeText: `Colete in masina: ${item.colete_inca_in_masina}`,
                    badgeColor: "light-danger",
                  },
                  {
                    badgeText: `Colete livrate: ${item.colete_livrate}`,
                    badgeColor: "light-success",
                  },
                ]
              : [],
        },
      ],
    };
  });
